import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CallTranscript } from '~/types/CallTranscript'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { SectionHeader } from './SectionHeader'

interface OfficeTalkSpeedSectionProps {
  transcript: CallTranscript
}

export const OfficeTalkSpeedSection = ({
  transcript,
}: OfficeTalkSpeedSectionProps) => {
  const { t } = useTranslation()
  const agentWordsPerMinute =
    transcript.ConversationCharacteristics.TalkSpeed.DetailsByParticipant.AGENT
      ?.AverageWordsPerMinute ?? 0

  return (
    <Flex
      flexDirection="column"
      width="100%"
      gap="1.5rem"
      justifyItems="stretch"
      height="7.125rem"
    >
      <SectionHeader
        title={t('callDetails.sections.officeTalkSpeed.title')}
        tooltipText={t('callDetails.sections.officeTalkSpeed.tooltip')}
      />
      <Flex flexDirection="column" justifyContent="center" flex="1 0 0">
        <Text
          {...textStyles[textStyleKeys.H1]}
          color="fg.default"
          marginTop="-1rem"
        >
          {agentWordsPerMinute}
        </Text>
        <Text {...textStyles[textStyleKeys.Body3]}>
          {t('callDetails.sections.officeTalkSpeed.wordsPerMinute')}
        </Text>
      </Flex>
    </Flex>
  )
}
